import type { JSX } from "react";
import type { MarkdownBlock as MarkdownBlockModel } from "@shared/types";
import { Markdown } from "../Markdown";
import { stripHiddenCiteMarkers } from "../../../lib/citations";
import type { BlockRendererProps } from "./registry";

/**
 * Default block renderer: prose. Wraps the existing markdown renderer (XSS-safe;
 * react-markdown emits no raw HTML) and strips 【来源N】 markers that point at
 * hidden sources, the same as the legacy directAnswer — the visible source chips
 * render at the turn level.
 */
export function MarkdownBlockView({ block, citations }: BlockRendererProps): JSX.Element {
  const md = block as MarkdownBlockModel;
  return <Markdown>{stripHiddenCiteMarkers(md.markdown, citations)}</Markdown>;
}
